import React, { useContext } from 'react';
import { RotationControls, RotationDirection, ImageRotationContext } from '../../../libs/gs-component-image-upload';

const PhotoRotation: React.FC = () => {
  const { rotateImageLeft, rotateImageRight } = useContext(ImageRotationContext);

  const rotateImage = (dir: RotationDirection): void => {
    if (dir === RotationDirection.Left) {
      rotateImageLeft();
      return;
    }

    rotateImageRight();
  };

  return <RotationControls onRotate={rotateImage} />;
};

export default PhotoRotation;
